import React, { type FC, useContext, useEffect, useState } from 'react'

import {
  Loading,
  MESSAGE_BOX_VARIANT_DANGER,
  MessageBox,
  PageHeader,
} from 'mailup-web-components'

import PageContainer from 'Components/PageContainer'

import { type AuthPageState } from 'Pages/authPage/model'
import { initApp } from 'Pages/authPage/services/services'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import AppStateContext from '../../contexts/AppStateContext'
import { getAuthParams } from '../../helpers/AuthHelper'

const AuthPage: FC = () => {
  const navigate = useNavigate()
  const intl = useIntl()

  const { seckey, list, redirectTo, loginType } = getAuthParams(
    window.location.search
  )

  const { changeLocale } = useContext(AppStateContext)

  const [pageState, setPageState] = useState<AuthPageState>({
    loading: false,
    status: 'initial',
  })

  useEffect(() => {
    setPageState((prev) => ({ ...prev, loading: true }))

    if (
      seckey !== null &&
      list !== null &&
      loginType !== null &&
      redirectTo !== null
    ) {
      initApp({
        seckey,
        idList: list,
        loginType,
      })
        .then((lang) => {
          changeLocale(lang)

          if (
            [
              'profile',
              'activity',
              'geolocation',
              'device',
              'engagement',
            ].includes(redirectTo)
          ) {
            navigate(`/filters/list`, {
              replace: true,
            })
          } else if (redirectTo.match(/^edit_(activity|device|geolocation|engagement|profile):\d+/) != null) {
            const params = redirectTo.split(':')
            navigate(`/filters/form/${encodeURIComponent(params[1])}`, {
              replace: true,
            })
          } else if (redirectTo.startsWith('/')) {
            navigate(redirectTo, {
              replace: true,
            })
          } else {
            navigate('/categories', {
              replace: true,
            })
          }
        })
        .catch((error) => {
          console.error('### error', error)
          setPageState((prev) => ({ ...prev, loading: false, status: 'error' }))
        })
    } else {
      //  wrong params
      console.error('### error', 'wrong params')
      setPageState((prev) => ({ ...prev, loading: false, status: 'error' }))
    }
  }, [])

  return (
    <>
      <PageHeader breadcrumbsItems={[]} menuItems={undefined} />
      <Loading open={pageState.loading} />
      <PageContainer>
        {pageState.status === 'error' && (
          <MessageBox variant={MESSAGE_BOX_VARIANT_DANGER}>
            {intl.formatMessage({ id: 'Load.Alerts.ErrorGeneric' })}
          </MessageBox>
        )}
      </PageContainer>
    </>
  )
}

export default AuthPage
